import { NgModule } from '@angular/core';

import { BaseModalComponent, TutorialModalComponent } from './components';

const modals = [BaseModalComponent, TutorialModalComponent];

export { BaseModalComponent, TutorialModalComponent };

@NgModule({
	imports: modals,
	exports: modals,
})
export class UiNewModals {}
